import { render } from "./IMIVVitaminTherapiesContent.vue?vue&type=template&id=fe6605e8&scoped=true"
import script from "./IMIVVitaminTherapiesContent.vue?vue&type=script&lang=js"
export * from "./IMIVVitaminTherapiesContent.vue?vue&type=script&lang=js"

import "./IMIVVitaminTherapiesContent.vue?vue&type=style&index=0&id=fe6605e8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fe6605e8"]])

export default __exports__